<div class="event-list-container" *ngIf="allEventsList.length > 0; else noEventsTemplate" [ngClass]="{'flex-align-start' : isUserProfilePage}">
  <p class="event-list-subtitle">{{ "HOMEPAGE.AVAILABLE_EVENTS" | translate }}</p>

  <div class="event-list">
    <ng-container *ngFor="let event of allEventsList">
      <div class="event" *ngIf="!event.isShownOnHero;" [ngClass]="{'add-new' : isUserProfilePage}">
        <div class="event-teams flex" *ngIf="!event.isGroup; else eventIsShownOnHero">
          <div class="team-logo" *ngIf="event.team1Logo">
            <img [src]="'img/logo-klubova/'+event.team1Logo"/>
          </div>

          <span class="separator" *ngIf="event.team2Name">VS</span>

          <div class="team-logo" *ngIf="event.team2Logo">
            <img [src]="'img/logo-klubova/'+event.team2Logo"/>
          </div>
        </div>

        <ng-template #eventIsShownOnHero>
          <div class="event-teams flex">
            <div class="group-ticket-img">
              <img [src]="'img/' + page + '/logo.png'"/>
            </div>
          </div>
        </ng-template>

        <p class="event-info mt-2" *ngIf="event.isGroup">{{ event.eventName }}</p>

        <p class="event-info mt-2">{{ event.eventGroupName }} {{ event.comment1 }}</p>
        <p class="event-date mb-2" *ngIf="event.startTime && !event.isGroup">{{ event.startTime | date:'dd.MM.yyyy - HH:mm':'Europe/Zagreb' }}</p>
        <p class="event-additional-date mb-2" *ngIf="event.isGroup">{{ event.venueName }}</p>

        <ng-container *ngFor="let action of event.actions">
          <button
            class="btn btn-secondary"
            *ngIf="(action.id === normalAction || action.id === subscriberAction) && action.membersExclusive"
            (click)="goToEventPage(event.connId, event, event.isGroup)">
            <ng-container *ngIf="currentOrderEventId === event.eventId; else eventIdDoesntMatch">
              {{ "COMMON.CONTINUE_SHOPPING" | translate }}
            </ng-container>
            <ng-template #eventIdDoesntMatch>
              {{ "HOMEPAGE.ONLY_FOR_CLUB_MEMBERS" | translate }}
            </ng-template>
          </button>

          <button
            class="btn btn-primary"
            (click)="goToEventPage(event.connId, event, event.isGroup)"
            *ngIf="((action.id === normalAction || action.id === subscriberAction || action.id === seasonExclusiveAction) && !action.membersExclusive) || ((action.id === seasonExclusiveAction) && action.membersExclusive)"
            >
            <span *ngIf="!event.isGroup; else eventIsGroup">
              <ng-container *ngIf="currentOrderEventId === event.eventId; else eventIdDoesntMatch">
                {{ "COMMON.CONTINUE_SHOPPING" | translate }}
              </ng-container>
              <ng-template #eventIdDoesntMatch>
                {{ "COMMON.BUY_TICKET" | translate }}
              </ng-template>
            </span>
            <ng-template #eventIsGroup>
              <span *ngIf="event.isGroup">
              <ng-container *ngIf="currentOrderEventId === event.eventId; else eventIdDoesntMatch">
                {{ "COMMON.CONTINUE_SHOPPING" | translate }}
              </ng-container>
              <ng-template #eventIdDoesntMatch>
                {{ "COMMON.BUY_GROUP_TICKET" | translate }}
              </ng-template>
              </span>
            </ng-template>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #noEventsTemplate>
  <!-- <app-socials></app-socials> -->
</ng-template>

<section id="event-modal-container" *ngIf="isEventModalOpen()">
  <div class="modal modal-container" (mousedown)="modalService.closeModal(modalNamesEnum.EventModal)">
    <div class="modal-inner" (mousedown)="$event.stopPropagation()">
      <div class="modal-content" (mousedown)="$event.stopPropagation()">
        <button type="button" class="btn-close" (click)="modalService.closeModal(modalNamesEnum.EventModal)" [attr.title]="'COMMON.CLOSE' | translate" [attr.aria-label]="'LOGIN.CLOSE_ARIA' | translate">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 17 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79287 8.6478L1 1.85493L1.70711 1.14783L8.49997 7.94069L15.2928 1.14783L15.9999 1.85493L9.20708 8.6478L15.4982 14.9389L14.7911 15.646L8.49997 9.35491L2.20887 15.646L1.50176 14.9389L7.79287 8.6478Z" fill="#797979"/>
            <path d="M1 1.85493L0.823223 1.67816C0.776339 1.72504 0.75 1.78863 0.75 1.85493C0.75 1.92124 0.776339 1.98483 0.823223 2.03171L1 1.85493ZM7.79287 8.6478L7.96964 8.82458C8.01653 8.77769 8.04287 8.7141 8.04287 8.6478C8.04287 8.5815 8.01653 8.51791 7.96964 8.47102L7.79287 8.6478ZM1.70711 1.14783L1.88388 0.97105C1.78625 0.873419 1.62796 0.873419 1.53033 0.97105L1.70711 1.14783ZM8.49997 7.94069L8.3232 8.11747C8.42083 8.2151 8.57912 8.2151 8.67675 8.11747L8.49997 7.94069ZM15.2928 1.14783L15.4696 0.97105C15.372 0.873419 15.2137 0.873419 15.1161 0.97105L15.2928 1.14783ZM15.9999 1.85493L16.1767 2.03171C16.2236 1.98483 16.2499 1.92124 16.2499 1.85493C16.2499 1.78863 16.2236 1.72504 16.1767 1.67816L15.9999 1.85493ZM9.20708 8.6478L9.0303 8.47102C8.93267 8.56865 8.93267 8.72694 9.0303 8.82458L9.20708 8.6478ZM15.4982 14.9389L15.675 15.1157C15.7726 15.0181 15.7726 14.8598 15.675 14.7621L15.4982 14.9389ZM14.7911 15.646L14.6143 15.8228C14.7119 15.9204 14.8702 15.9204 14.9679 15.8228L14.7911 15.646ZM8.49997 9.35491L8.67675 9.17813C8.57912 9.0805 8.42083 9.0805 8.3232 9.17813L8.49997 9.35491ZM2.20887 15.646L2.03209 15.8228C2.12972 15.9204 2.28801 15.9204 2.38564 15.8228L2.20887 15.646ZM1.50176 14.9389L1.32498 14.7621C1.2781 14.809 1.25176 14.8726 1.25176 14.9389C1.25176 15.0052 1.2781 15.0688 1.32498 15.1157L1.50176 14.9389ZM0.823223 2.03171L7.61609 8.82458L7.96964 8.47102L1.17678 1.67816L0.823223 2.03171ZM1.53033 0.97105L0.823223 1.67816L1.17678 2.03171L1.88388 1.3246L1.53033 0.97105ZM8.67675 7.76392L1.88388 0.97105L1.53033 1.3246L8.3232 8.11747L8.67675 7.76392ZM8.67675 8.11747L15.4696 1.3246L15.1161 0.97105L8.3232 7.76392L8.67675 8.11747ZM15.1161 1.3246L15.8232 2.03171L16.1767 1.67816L15.4696 0.97105L15.1161 1.3246ZM15.8232 1.67816L9.0303 8.47102L9.38386 8.82458L16.1767 2.03171L15.8232 1.67816ZM15.675 14.7621L9.38386 8.47102L9.0303 8.82458L15.3214 15.1157L15.675 14.7621ZM14.9679 15.8228L15.675 15.1157L15.3214 14.7621L14.6143 15.4692L14.9679 15.8228ZM8.3232 9.53168L14.6143 15.8228L14.9679 15.4692L8.67675 9.17813L8.3232 9.53168ZM8.3232 9.17813L2.03209 15.4692L2.38564 15.8228L8.67675 9.53168L8.3232 9.17813ZM2.38564 15.4692L1.67853 14.7621L1.32498 15.1157L2.03209 15.8228L2.38564 15.4692ZM1.67853 15.1157L7.96964 8.82458L7.61609 8.47102L1.32498 14.7621L1.67853 15.1157Z" fill="#797979"/>
          </svg>
        </button>

        <div class="modal-body">
          <app-season-ticket [selectedEvent]="selectedEvent" parent="events-list"></app-season-ticket>
        </div>
      </div>

      <div class="modal-aside">
        <div class="modal-card-img">
          <img [src]="'img/' + page + '/iskaznica.png'" alt="" />
        </div>
        <div class="modal-chant-img">
          <img [src]="'img/' + page + '/zajedno.png'" alt="" />
        </div>
        <div class="modal-aside-content">
          <p>{{'REGISTER.MEMBER_1' | translate}}</p>
          <p class="mt-2">{{'REGISTER.MEMBER_2' | translate}}</p>
          <!-- <button type="button" class="btn btn-secondary">{{'REGISTER.BTN_MORE' | translate}}</button> -->
        </div>
      </div>
    </div>
  </div>
</section>
